/**
 * Everything the frontend needs to know about the local Printer Adapter Service, mirroring the
 * values the adapter itself is built with (`hs-printer-adapter`).
 *
 * Deliberately not environment variables: the adapter hardcodes its own binding and has its
 * manifest URL compiled in as assembly metadata at publish time, so a per-deployment override
 * here could only ever disagree with the service it is talking to.
 */

/**
 * Where the adapter listens - `ApplicationHost.Init`: `UseUrls("http://localhost:6700")` and
 * `MapHub<MainHub>("/connection")`. Loopback only, so the URL is identical on every machine.
 */
export const PRINTER_ADAPTER_HOST = 'localhost';
export const PRINTER_ADAPTER_PORT = 6700;
export const PRINTER_ADAPTER_HUB_PATH = '/connection';

export const PRINTER_ADAPTER_ORIGIN = `http://${PRINTER_ADAPTER_HOST}:${PRINTER_ADAPTER_PORT}`;
export const PRINTER_ADAPTER_HUB_URL = `${PRINTER_ADAPTER_ORIGIN}${PRINTER_ADAPTER_HUB_PATH}`;

/**
 * The release manifest the adapter's CI publishes and every installed adapter polls - the same URL
 * baked into the adapter as `UpdateManifestUrl` (GitHub Actions variable `UPDATE_MANIFEST_URL`).
 *
 * It is a publicly readable blob, overwritten in place on every release and served `no-cache`, so
 * reading it is how the page offers the *current* installer instead of a hardcoded one. The
 * installer blobs themselves stay private behind the 5-year SAS the manifest hands out.
 */
export const PRINTER_ADAPTER_MANIFEST_URL =
  'https://infrastweu001.blob.core.windows.net/manifests/HealthSystem.PrinterAdapter/latest.json';
